import React, { Component } from "react";
import { Link } from "react-router-dom";

import "../../public/scss/feedComponent.scss";

import AppFeedComponent from "./feedTypes/AppFeedComponent";
import AutoPopulatedFeedComponent from "./feedTypes/AutoPopulatedFeedComponent";
import PlannerFeedComponent from "./feedTypes/PlannerFeedComponent";
import AutoPopulatedFeedResults from "./feedTypes/AutoPopulatedFeedResults";

import AddPostComponent from "./../addPost/AddPostComponent";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartBar,
  faComments,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

// import Time from 'react-time-format';

// import store from './../store';
import PropTypes from "prop-types";
import {
  getStudentData,
  getStudentNextData,
  getDashboardData,
  getDashboardNextData,
  getAllAssignedPrograms,
  notifyReadFeedStatus,
  getReferralPrice,
} from "./../../actions/feedActions";
import { connect } from "react-redux";

import HeaderComponent from "./HeaderComponent";
import SideProfile from "./SideProfileComponent";
import { Tooltip } from "reactstrap";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Button,
  ButtonGroup,
  Container,
  Row,
  Media,
  Col,
  Card,
  CardTitle,
  CardSubtitle,
  CardBody,
  CardText,
  CardLink,
  Badge,
  Spinner,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  // NavLink
} from "reactstrap";
import EvaluationComponent from "./feedTypes/EvaluationComponent";
import HomeComponent from "./feedTypes/HomeComponent";
import DemoStudentView from "./feedTypes/DemoStudentView";
import ScoresFeed from "./feedTypes/ScoresFeed";
import InvoicesStudents from "./InvoicesStudents";
import StudentProfileView from "./StudentProfileView";

class StudentInvoiceView extends Component {
  constructor(props) {
    super(props);
    //console.log(props);
    this.state = {
      // isWhiteLabel:
      //   window.location.host == "feeds.lincolnmethod.com" ? false : true,
      isWhiteLabel: true,
      studentId: props.match.params.kidId,
      // studentId : "",
      studentInfo: {},
      studentGrade: "",
      feedsLoading: false,
      feeds: [],
      feedsIndexValue: 1,
      feedsKeys: [],
      lastUpdateProp: "",
      photoIndex: [],
      isOpen: [],
      showDetails: [],
      showWorksheets: [],
      triggerPreviewStats: false,
      studentProgarms: [],
      topicVideos: [],
      topicWorkSheets: [],
      // states below are designated to autoPopulated dashboard posts
      studentAssessments: [],
      assessmentFeedIndex: 0,
      programRelatedData: [],
      randomImages: [],
      dashboardDataArray: [],
      notifications: [],
      loadMoreLoader: false,
      loadMoreLoaderTutor: false,
      loadMoreFlag: false,
      loadMoreText: "loading..",
      loadMoreTextTutor: "loading..",
      enableStudentUpload: true,
      feedsType: "invoices",
      palnnerBadgeCount: 0,
      plannerData: [],
      tooltipOpen: false,
      tooltipOpen2: false,
      rewardPrice: "",
    };
  }

  componentWillReceiveProps(nextProps, thisProps) {
    if (this.props.studentData != nextProps.studentData) {
      // console.log(nextProps.studentData)

      if (nextProps.studentData.studentData) {
        this.setState({
          studentInfo: nextProps.studentData.studentData,
        });
      }

      if (
        nextProps.studentData.notifications &&
        nextProps.studentData.notifications.length
      ) {
        this.setState(
          {
            notifications: nextProps.studentData.notifications,
          },
          () => {
            console.log(this.state.notifications);
          }
        );
      }

      if (
        nextProps.studentData.feedsData &&
        nextProps.studentData.feedsData.length
      ) {
        var tempFeeds = this.state.feeds;
        var tempTopicVideos = this.state.topicVideos;
        var tempTopicWorkSheets = this.state.topicWorkSheets;

        nextProps.studentData.feedsData.map((feed) => {
          tempFeeds.push(feed);
        });

        tempTopicVideos.push(nextProps.studentData.topicVideos);
        tempTopicWorkSheets.push(nextProps.studentData.topicWorkSheets);

        this.setState(
          {
            feedsLoading: false,
            feeds: tempFeeds, // setting up the feeds
            topicVideos: tempTopicVideos,
            topicWorkSheets: tempTopicWorkSheets,
            feedsIndexValue: this.state.feedsIndexValue + 1,
          },
          () => {
            console.log(this.state.feeds);
            document.addEventListener(
              "scroll",
              this.trackScrollingForTutorFeeds
            );

            // console.log(this.state.topicVideos)
            // console.log(this.state.topicWorkSheets)

            // get all programs assigned to this student
            this.props.getAllAssignedPrograms(
              this.state.feeds[0].feed_studentid
            );

            var photoIndexArray = this.state.photoIndex;
            var isOpenArray = this.state.isOpen;
            var showDetailsArray = this.state.showDetails;
            var showWorksheetsArray = this.state.showWorksheets;

            this.state.feeds.map((item, key) => {
              photoIndexArray.push(0);
              isOpenArray.push(false);
              showDetailsArray[key] = false;
              showWorksheetsArray[key] = false;
            });

            this.setState(
              {
                photoIndex: photoIndexArray,
                isOpen: isOpenArray,
                showDetails: showDetailsArray,
                showWorksheets: showWorksheetsArray,
                studentGrade: this.state.feeds[0].group_name, // set the grade for student
              },
              () => {
                // console.log(this.state.photoIndex)
                // console.log(this.state.isOpen)

                var timeStamp = this.state.feeds[0].ts;
                var splittedTimeStamp = timeStamp.split(" ");
                var dateTime = this.formatDate(splittedTimeStamp[0]);
                this.setState({
                  lastUpdateProp: dateTime,
                });
              }
            );
          }
        );
      } else {
        this.setState({
          feedsLoading: false,
          loadMoreLoaderTutor: false,
        });
      }
    }

    if (this.props.assignedPrograms != nextProps.assignedPrograms) {
      if (
        nextProps.assignedPrograms.data &&
        nextProps.assignedPrograms.data.result.length
      ) {
        this.setState(
          {
            studentProgarms: nextProps.assignedPrograms.data.result,
          },
          () => {
            // console.log(this.state.studentProgarms)
            // this.setState({
            //     enableStudentUpload : true
            // })
          }
        );
      }
    }

    // props for getting data from autopopulted dashboard feeds ************* only for dashboard auto populated posts **************
    if (this.props.dashboardData != nextProps.dashboardData) {
      console.log("This is the dashboard data:", nextProps.dashboardData);
      debugger;
      if (typeof nextProps.dashboardData.plannerData !== "undefined")
        this.setState({
          plannerData: nextProps.dashboardData.plannerData,
          palnnerBadgeCount: nextProps.dashboardData.plannerData.length,
        }); //setting planner data

      if (nextProps.dashboardData.studentData) {
        this.setState({
          studentInfo: nextProps.dashboardData.studentData,
          feedsType:
            nextProps.dashboardData.studentData.client_id === 3
              ? "dashboard"
              : "invoices",
        });
      }
      if (nextProps.dashboardData.programs) {
        this.setState(
          {
            studentProgarms: nextProps.dashboardData.programs,
          },
          () => {
            // console.log(this.state.studentProgarms)
            // this.setState({
            //     enableStudentUpload : true
            // })
          }
        );
      }
      if (nextProps.dashboardData.randomImages) {
        this.setState(
          {
            randomImages: nextProps.dashboardData.randomImages,
          },
          () => {
            this.sortRandomImages(this.state.randomImages); // sorting images
          }
        );
      }
      if (
        nextProps.dashboardData.chapters &&
        nextProps.dashboardData.chapters.length
      ) {
        this.setState(
          {
            studentAssessments: nextProps.dashboardData.chapters,
          },
          () => {
            console.log(this.state.studentAssessments);
          }
        );
      }

      if (nextProps.dashboardData.feeds) {
        var tempDashboardDataArray = this.state.dashboardDataArray;
        tempDashboardDataArray.push({
          programRelatedData: nextProps.dashboardData.programRelatedData,
          feeds: nextProps.dashboardData.feeds,
          topicVideos: nextProps.dashboardData.topicVideos,
          topicWorkSheets: nextProps.dashboardData.topicWorkSheets,
          // randomImages : nextProps.dashboardData.randomImages
        });
        debugger;
        this.setState(
          {
            dashboardDataArray: tempDashboardDataArray,
            loadMoreLoader: false,
          },
          () => {
            console.log(this.state.dashboardDataArray);
            document.addEventListener("scroll", this.trackScrolling);
            // var dataArrayWithIndex = this.state.dashboardDataArray[this.state.assessmentFeedIndex];

            // if(dataArrayWithIndex.feeds) {
            //     this.setState({
            //         feeds : dataArrayWithIndex.feeds
            //     }, () => {
            //         this.setState({
            //             feedsKeys : Object.keys(this.state.feeds)
            //         })
            //     })
            // }
            // if(dataArrayWithIndex.topicVideos) {
            //     this.setState({
            //         topicVideos : dataArrayWithIndex.topicVideos
            //     }, () => {
            //         // console.log(this.state.topicVideos);
            //     })
            // }
            // if(dataArrayWithIndex.programRelatedData) {
            //     this.setState({
            //         programRelatedData : dataArrayWithIndex.programRelatedData
            //     }, () => {
            //         console.log(this.state.programRelatedData);
            //     })
            // }

            // if(dataArrayWithIndex.randomImages) {
            //     this.setState({
            //         randomImages : dataArrayWithIndex.randomImages
            //     }, () => {
            //         this.sortRandomImages(this.state.randomImages); // sorting images
            //     })
            // }
          }
        );

        console.log(this.checkIfWeAreShowing(nextProps.dashboardData.feeds));
        // if (!this.checkIfWeAreShowing(nextProps.dashboardData.feeds)) {
        //   this.setState(
        //     {
        //       loadMoreLoader: true,
        //     },
        //     () => {
        //       try {
        //         var feedAssessmentByIndex = this.state.studentAssessments[
        //           this.state.dashboardDataArray.length
        //         ];
        //         // console.log(feedAssessmentByIndex);
        //         this.props.getDashboardNextData(
        //           this.state.studentId,
        //           feedAssessmentByIndex.assessment_id,
        //           feedAssessmentByIndex.name,
        //           feedAssessmentByIndex.prog_id
        //         );

        //         document.removeEventListener("scroll", this.trackScrolling);
        //       } catch (e) {
        //         console.log(e);
        //         document.removeEventListener("scroll", this.trackScrolling);
        //         this.setState({
        //           loadMoreLoader: false,
        //           loadMoreText: "No more posts",
        //         });
        //       }
        //     }
        //   );
        // }
      }
    }

    // get the reducer state for switching views for dahboard data or app data
    if (this.props.whiteLabelProp != nextProps.whiteLabelProp) {
      document.removeEventListener("scroll", this.trackScrolling);
      document.removeEventListener("scroll", this.trackScrollingForTutorFeeds);
      //   if(nextProps.whiteLabelProp.indexOf("tuitions") > -1) {
      this.setState(
        {
          isWhiteLabel: !this.state.isWhiteLabel,
        },
        () => {
          this.setState(
            {
              feedsLoading: true,
            },
            () => {
              if (this.state.isWhiteLabel) {
                this.props.getDashboardData(this.state.studentId);
                document.addEventListener("scroll", this.trackScrolling);
                document.removeEventListener(
                  "scroll",
                  this.trackScrollingForTutorFeeds
                );
              } else {
                this.props.getStudentData(
                  this.state.studentId,
                  this.state.feedsIndexValue
                ); // calls action for getting data for selected student
                document.removeEventListener("scroll", this.trackScrolling);
                document.addEventListener(
                  "scroll",
                  this.trackScrollingForTutorFeeds
                );
              }
            }
          );
        }
      );
      //   }
      //   else{
      //     this.setState({
      //         isWhiteLabel : true
      //     })
      //   }
    }
  }

  checkIfWeAreShowing(newFeeds) {
    var loadMoreFlag = false;
    Object.keys(newFeeds).map((id) => {
      var feeds = newFeeds[id];

      Object.keys(feeds).map((id, key) => {
        var feed = feeds[id];
        if (parseInt(feed.beforeScore) > 0 && parseInt(feed.afterScore) == 0) {
          loadMoreFlag = true;
        }
      });
    });

    if (loadMoreFlag) {
      return true;
    } else {
      return false;
    }
  }

  isBottom(el) {
    try {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    } catch (e) {
      return false;
    }
  }

  trackScrollingForTutorFeeds = () => {
    const wrappedElement = document.getElementById("onScrollLoadingTutor");
    if (this.isBottom(wrappedElement)) {
      console.log("onScrollLoadingTutor reached");

      this.setState(
        {
          loadMoreLoaderTutor: true,
        },
        () => {
          try {
            this.props.getStudentNextData(
              this.state.studentId,
              this.state.feedsIndexValue
            );
            document.removeEventListener(
              "scroll",
              this.trackScrollingForTutorFeeds
            );
          } catch (e) {
            console.log(e);
            document.removeEventListener(
              "scroll",
              this.trackScrollingForTutorFeeds
            );
            this.setState({
              loadMoreLoaderTutor: false,
              loadMoreLoaderTutorText: "No more posts",
            });
          }
        }
      );
    }
  };

  trackScrolling = () => {
    const wrappedElement = document.getElementById("onScrollLoading");
    if (this.isBottom(wrappedElement)) {
      debugger;
      console.log("onScrollLoading reached");

      this.setState(
        {
          loadMoreLoader: true,
        },
        () => {
          try {
            var feedAssessmentByIndex =
              this.state.studentAssessments[
                this.state.dashboardDataArray.length
              ];
            // console.log(feedAssessmentByIndex);
            this.props.getDashboardNextData(
              this.state.studentId,
              feedAssessmentByIndex.assessment_id,
              feedAssessmentByIndex.name,
              feedAssessmentByIndex.prog_id
            );

            document.removeEventListener("scroll", this.trackScrolling);
          } catch (e) {
            console.log(e);
            document.removeEventListener("scroll", this.trackScrolling);
            this.setState({
              loadMoreLoader: false,
            });
          }
        }
      );
    }
  };

  sortRandomImages(randomImages) {
    var images = randomImages;

    var imagesBefore = [];
    var imagesAfter = [];
    images.map((image, key) => {
      if (image.image_for == "before") {
        imagesBefore.push(image);
      } else {
        imagesAfter.push(image);
      }
    });

    var b_inadequate = [];
    var b_marginal = [];
    var b_adequate = [];
    var b_good = [];
    var b_excellent = [];
    var a_inadequate = [];
    var a_marginal = [];
    var a_adequate = [];
    var a_good = [];
    var a_excellent = [];

    imagesBefore.map((image, key) => {
      if (image.image_grade == "inadequate") {
        b_inadequate.push(image);
      } else if (image.image_grade == "marginal") {
        b_marginal.push(image);
      } else if (image.image_grade == "adequate") {
        b_adequate.push(image);
      } else if (image.image_grade == "good") {
        b_good.push(image);
      } else if (image.image_grade == "excellent") {
        b_excellent.push(image);
      }
    });

    imagesAfter.map((image, key) => {
      if (image.image_grade == "inadequate") {
        a_inadequate.push(image);
      } else if (image.image_grade == "marginal") {
        a_marginal.push(image);
      } else if (image.image_grade == "adequate") {
        a_adequate.push(image);
      } else if (image.image_grade == "good") {
        a_good.push(image);
      } else if (image.image_grade == "excellent") {
        a_excellent.push(image);
      }
    });

    this.setState(
      {
        randomImages: {
          before: {
            inadequate: b_inadequate,
            marginal: b_marginal,
            adequate: b_adequate,
            good: b_good,
            excellent: b_excellent,
          },
          after: {
            inadequate: a_inadequate,
            marginal: a_marginal,
            adequate: a_adequate,
            good: a_good,
            excellent: a_excellent,
          },
        },
      },
      () => {
        console.log(this.state.randomImages);
      }
    );
  }

  componentDidMount() {
    // var loginStatus = localStorage.getItem("loginData");
    // if (loginStatus != null && typeof JSON.parse(loginStatus) === "object") {
    //   this.setState(
    //     {
    //       studentId: JSON.parse(loginStatus).user.id, // student id
    //     },
    //     () => {
    // debugger;

    getReferralPrice(this.state.studentId).then((res) => {
      this.setState({
        rewardPrice: res?.data?.result?.referral_reward,
      });
      console.log("Reward Price", res);
    });
    if (
      this.state.studentId &&
      this.state.studentId !== "" &&
      this.state.studentId != undefined
    ) {
      this.setState(
        {
          feedsLoading: true,
        },
        () => {
          var hash = window.location.hash;
          var messageId =
            hash.indexOf("#state") > -1 ? hash.split("#state") : null;
          messageId = messageId && messageId[1];
          var userId =
            messageId && messageId.indexOf("#id") > -1
              ? messageId.split("#id")
              : null;
          messageId = userId && userId[0];
          userId = userId && userId[1];
          console.log(messageId, userId);

          if (messageId && userId) {
            this.props.notifyReadFeedStatus(userId, messageId);
          }

          if (this.state.isWhiteLabel) {
            this.props.getDashboardData(this.state.studentId);
          } else {
            this.props.getStudentData(
              this.state.studentId,
              this.state.feedsIndexValue
            ); // calls action for getting data for selected student
          }
        }
      );
    }
    //     }
    //   );
    // }

    if (this.state.isWhiteLabel) {
      // debugger;
      document.addEventListener("scroll", this.trackScrolling);
    } else {
      debugger;
      document.addEventListener("scroll", this.trackScrollingForTutorFeeds);
    }
  }

  formatDate(date) {
    var newDate = date.split("-");
    newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

    return newDate;
  }

  componentWillUnmount() {
    if (this.state.isWhiteLabel) {
      document.removeEventListener("scroll", this.trackScrolling);
    } else {
      document.removeEventListener("scroll", this.trackScrollingForTutorFeeds);
    }
  }

  toggleChart = () => {
    this.setState({
      triggerPreviewStats: !this.state.triggerPreviewStats,
    });
  };

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };
  toggle2 = () => {
    this.setState({
      tooltipOpen2: !this.state.tooltipOpen2,
    });
  };
  render() {
    const { feedId = 0 } = this.props.match.params;
    return (
      <div className="FeedComponent">
        {!this.state.isWhiteLabel ? (
          <Button
            className="toggleIcon"
            size="lg"
            color={this.state.triggerPreviewStats ? "secondary" : "primary"}
            onClick={(e) => this.toggleChart()}
          >
            <FontAwesomeIcon
              icon={this.state.triggerPreviewStats ? faTimes : faComments}
              size="1x"
              color="#fff"
            />
          </Button>
        ) : null}

        <HeaderComponent
          whiteLabel={this.state.isWhiteLabel}
          headerData={{ studentName: this.state.studentInfo.user_name }}
          clientId={this.state.studentInfo.client_id}
          studentId={this.props.match.params.kidId}
          studentView={true}
        />

        <div style={{ textAlign: "left", padding: "3vh 0" }}>
          <Container fluid>
            {/* {this.state.studentInfo.client_id === 3 ? null : (
              <Row className="justify-content-center">
                <Col sm="6">
                  <div className="mobileViewTabs">
                    <Link to={`/${this.state.studentId}`}>
                      <button
                        className={
                          this.state.feedsType == "home" && feedId <= 0
                            ? "btnTabSelected"
                            : "btnTab"
                        }
                        onClick={(event) => {
                          this.setState({ feedsType: "home" });
                        }}
                      >
                        <i className="fas fa-home"></i> <br />
                        <label>Home</label>
                      </button>
                    </Link>
                    <button
                      className={
                        this.state.feedsType == "dashboard"
                          ? "btnTabSelected"
                          : "btnTab"
                      }
                      onClick={(event) => {
                        this.setState({ feedsType: "dashboard" });
                      }}
                    >
                      <i className="fas fa-sort-numeric-down"></i> <br />
                      <label>Score</label>
                    </button>
                    <button
                      className={
                        this.state.feedsType == "planner"
                          ? "btnTabSelected"
                          : "btnTab"
                      }
                      onClick={(event) => {
                        this.setState({ feedsType: "planner" });
                      }}
                    >
                      <i className="fas fa-file"></i> <br />
                      <label>Planner</label>
                    </button>
                    <button
                      className={
                        this.state.feedsType == "evaluation"
                          ? "btnTabSelected"
                          : "btnTab"
                      }
                      onClick={(event) => {
                        this.setState({ feedsType: "evaluation" });
                      }}
                    >
                      <i className="fas fa-poll"></i> <br />
                      <label>Evaluation</label>
                    </button>
                  </div>
                  <ButtonGroup className="feedOptionButtons">
                    <button
                      onClick={(event) => {
                        console.log("Faheem, show the planner");
                        this.setState({ feedsType: "invoices" });
                      }}
                      className={
                        this.state.feedsType == "invoices"
                          ? "btnForRouteSelected"
                          : "btnForRoute"
                      }
                    >
                      Invoices
                      <span className="redDot"></span>
                    </button>
                  </ButtonGroup>
                </Col>
              </Row>
            )} */}
            <Row>
              <Col md={{ size: 3 }}>
                <SideProfile
                  data={this.state.studentInfo}
                  candidateGrade={this.state.studentGrade}
                  lastUpdate={this.state.lastUpdateProp}
                  programs={this.state.studentProgarms}
                  notifications={this.state.notifications}
                  type="info"
                ></SideProfile>
              </Col>

              {this.state.feedsType == "invoices" ? (
                <Col
                  className="feedContainer"
                  md={{ size: 9 }}
                  style={{ textAlign: "center" }}
                >
                  {/* <InvoicesStudents studentId={this.state.studentId} /> */}
                  <StudentProfileView studentid={this.state.studentId} />
                </Col>
              ) : (
                <Col
                  className="feedContainer"
                  md={{ size: 6 }}
                  style={{ textAlign: "center" }}
                ></Col>
              )}

              {!this.state.isWhiteLabel && this.state.feedsType != "planner" ? (
                <Col md={{ size: 3 }}>
                  <SideProfile
                    statsData={{
                      data: this.state.feeds,
                      random: Math.random(),
                    }}
                    type="analytics"
                    isPreview={false}
                    // isPreview={this.state.triggerPreviewStats}
                  ></SideProfile>
                </Col>
              ) : null}
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

StudentInvoiceView.propTypes = {
  getStudentData: PropTypes.func.isRequired,
  getStudentNextData: PropTypes.func.isRequired,
  getDashboardData: PropTypes.func.isRequired,
  getDashboardNextData: PropTypes.func.isRequired,
  getAllAssignedPrograms: PropTypes.func.isRequired,
  notifyReadFeedStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  studentData: state.feedRed.studentData,
  dashboardData: state.feedRed.dashboardData,
  assignedPrograms: state.feedRed.assignedPrograms,
  whiteLabelProp: state.feedRed.whiteLabelProp,
});

export default connect(mapStateToProps, {
  getStudentData,
  getStudentNextData,
  getDashboardData,
  getDashboardNextData,
  getAllAssignedPrograms,
  notifyReadFeedStatus,
})(StudentInvoiceView);
